module.exports = __webpack_public_path__ + "static/media/armadillo-header-logo.9e861c6c.png";